import { useEffect, useState } from "react";

// Matches Tailwind's lg: breakpoint — the point where the desktop sidebar appears.
// All mobile-specific UI (bottom nav, etc.) is hidden above this threshold.
const MOBILE_BREAKPOINT = 1024;

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth < MOBILE_BREAKPOINT,
  );

  useEffect(() => {
    // jsdom (and some embedded WebViews) have no matchMedia: keep the
    // initial width reading rather than crash the page.
    if (typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return isMobile;
}
